export const preLoadFontsForPresentationDetail = () => {
  try {
    const fonts = [
      'https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap&subset=latin-ext,vietnamese',
      'https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap&subset=latin-ext,vietnamese',
      'https://fonts.googleapis.com/css?family=Oswald:400,700&display=swap&subset=latin-ext,vietnamese',
      'https://fonts.googleapis.com/css?family=Montserrat:400,700&display=swap&subset=latin-ext,vietnamese',
      'https://fonts.googleapis.com/css?family=Source+Code+Pro:400,700&display=swap&subset=latin-ext,vietnamese',
      'https://fonts.googleapis.com/css?family=Merriweather:400,700&display=swap&subset=latin-ext,vietnamese',
      'https://fonts.googleapis.com/css?family=EB+Garamond:400,700&display=swap&subset=latin-ext,vietnamese',
      'https://fonts.googleapis.com/css?family=Roboto+Slab:400,700&display=swap&subset=latin-ext,vietnamese',
      'https://fonts.googleapis.com/css?family=Cairo:400,700&display=swap&subset=arabic',
      'https://fonts.googleapis.com/css?family=Kanit:400,700&display=swap&subset=thai',
    ]

    // Tạo Set chứa tất cả href hiện tại trong head
    const existingHrefs = new Set(
      Array.from(document.head.querySelectorAll('link[rel="stylesheet"]'))
        .map((el) => el.href),
    )

    fonts.forEach((link) => {
      if (!existingHrefs.has(link)) {
        const elLink = document.createElement('link')
        elLink.href = link
        elLink.rel = 'stylesheet'
        document.head.appendChild(elLink)
      }
    })
  } catch (error) {
    // do nothing
  }
}
